var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upcoming-events-carousel" },
    [
      _c("carousel", {
        attrs: { variant: "show1", selector: ".carousel-wrapper" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var imageLoadedEvent = ref.imageLoadedEvent
              var canLoad = ref.canLoad
              return _c("div", { staticClass: "carousel component" }, [
                _c(
                  "div",
                  { staticClass: "carousel-wrapper show1" },
                  _vm._l(_vm.carouselEventsList, function (event, index) {
                    return _c("UpcomingEventsSlide", {
                      key: "carousel-event-" + event.eventId + "-" + index,
                      attrs: {
                        event: event,
                        "image-loaded-event": imageLoadedEvent,
                        "can-load": canLoad,
                      },
                    })
                  }),
                  1
                ),
              ])
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }